import { usePageViewTracking } from "hooks/usePageViewTracking";

/**
 * Renders nothing; tracks page/screen views on route change when mounted inside Router.
 * Mount inside PrivateLayout so authenticated users get screen_viewed events.
 */
export const PageViewTracker = () => {
  usePageViewTracking();
  return null;
};
